// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-collect-dialog[data-v-3f71b141]  .dialog-body .el-form-item__label {\n  line-height: 20px;\n}\n.edit-collect-dialog[data-v-3f71b141]  .el-form--label-top .el-form-item__label {\n  padding-bottom: 8px;\n}\n.edit-collect-dialog .dialog-footer[data-v-3f71b141] {\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
